import type { Messages } from './en';

export const de: Messages = {
  'nav.clientHub': 'Kundenportal',
  'nav.menu': 'Menü',
  'nav.home': 'Start',
  'nav.products': 'Produkte',
  'nav.liveCasino': 'Live Casino',
  'nav.slots': 'Slots',
  'nav.tableGames': 'Tischspiele',
  'nav.library': 'Bibliothek',
  'nav.roadmap': 'Roadmap',
  'nav.assets': 'Assets',
  'nav.guidelines': 'Richtlinien',
  'nav.account': 'Konto',
  'nav.signOut': 'Abmelden',
  'nav.categoriesAria': 'Spielkategorien',
  'nav.sectionsAria': 'Hauptbereiche',
  'nav.brandAria': 'RichyPlay Kundenportal',
  'nav.comingSoon': 'Demnächst',
  'nav.soon': 'Bald',

  'lang.label': 'Sprache',
  'lang.select': 'Sprache auswählen',

  'category.live': 'Live',
  'category.slot': 'Slots',
  'category.instant': 'Instant',
  'category.table': 'Tisch',

  'status.planned': 'Geplant',
  'status.in_progress': 'In Arbeit',
  'status.shipped': 'Veröffentlicht',
  'status.available': 'Verfügbar',
  'status.coming_soon': 'Demnächst',
  'status.maintenance': 'Wartung',

  'common.error': 'Etwas ist schiefgelaufen',
  'common.checkingSession': 'Sitzung wird geprüft…',
  'common.yes': 'Ja',
  'common.no': 'Nein',
  'common.none': 'Keiner',
  'common.active': 'Aktiv',
  'common.inactive': 'Inaktiv',

  'home.eyebrow': 'Betreiberportal',
  'home.title': 'Kundenportal',
  'home.lead':
    'Entdecken Sie das RichyPlay-Portfolio — starten Sie Demos, verfolgen Sie die Roadmap und laden Sie Markenassets aus einem einzigen Arbeitsbereich herunter.',
  'home.enterLibrary': 'Zur Bibliothek',
  'home.viewRoadmap': 'Roadmap ansehen',
  'home.browse': 'Nach Kategorie durchsuchen',
  'home.openLibrary': 'Bibliothek öffnen',

  'library.eyebrow': 'Spielbibliothek',
  'library.title': 'Portfolio',
  'library.liveTitle': 'Live Casino Portfolio',
  'library.slotTitle': 'Slot Portfolio',
  'library.liveLead': 'Wählen Sie ein Live-Produkt. Blackjack und Roulette sind live; der Rest folgt in Kürze.',
  'liveFamily.roulette': 'Royal Roulette',
  'liveFamily.blackjack': 'Royal Blackjack',
  'liveFamily.autoRoulette': 'Auto Roulette',
  'liveFamily.thunderRoulette': 'Thunder Roulette',
  'liveFamily.infinityBlackjack': 'Infinity Blackjack',
  'liveFamily.baccarat': 'Baccarat',
  'liveFamily.poker': 'Poker',
  'liveFamily.dice': 'Dice',
  'liveFamily.showGames': 'Show Games',
  'library.lead':
    'Durchsuchen und filtern Sie den RichyPlay-Katalog. Demos starten in einem neuen Tab.',
  'library.search': 'Spiele suchen…',
  'library.statusFilterAria': 'Nach Status filtern',
  'library.statusAll': 'Alle Status',
  'library.loading': 'Spiele werden geladen…',
  'library.unavailableTitle': 'Bibliothek nicht verfügbar',
  'library.unavailableMessage':
    'Die Spielbibliothek konnte nicht geladen werden. Der Katalog ist möglicherweise nicht verfügbar.',
  'library.apiFailedMessage':
    'Die Katalog-API war nicht erreichbar. Versuchen Sie es später erneut oder wenden Sie sich an den Support.',
  'library.emptyTitle': 'Keine Spiele gefunden',
  'library.emptyMessage': 'Versuchen Sie eine andere Suche oder einen anderen Kategoriefilter.',
  'library.viewGame': 'Spiel ansehen',

  'game.loading': 'Spiel wird geladen…',
  'game.notFound': 'Spiel nicht gefunden.',
  'game.back': 'Zurück',
  'game.breadcrumbAria': 'Navigationspfad',
  'game.liveCasino': 'Live-Casino',
  'game.slots': 'Slots',
  'game.demoFrameTitle': '{title} Demo',
  'game.startingDemo': 'Demo-Sitzung wird gestartet…',
  'game.demoNotStarted': 'Die Demo-Sitzung konnte nicht gestartet werden.',
  'game.demoBadge': 'Demomodus',
  'game.blockedMaintenance': 'Dieses Spiel befindet sich in Wartung.',
  'game.blockedComingSoon': 'Demnächst — die Demo ist noch nicht veröffentlicht.',
  'game.blockedNoDemo': 'Der Betreiberkatalog stellt für diesen Titel keine Demoversion bereit.',
  'game.currency': 'Währung',
  'game.language': 'Sprache',
  'game.reloadDemo': 'Demo neu laden',
  'game.startDemo': 'Demo starten',
  'game.openNewTab': 'In neuem Tab öffnen',
  'game.copyLink': 'Link kopieren',
  'game.copied': 'Kopiert',
  'game.demoFailedTitle': 'Demostart fehlgeschlagen',
  'game.demoUrlMissing': 'Der Server hat keine Start-URL zurückgegeben.',
  'game.demoFailed': 'Die Demo konnte nicht gestartet werden.',
  'game.highlighted': 'Hervorgehoben',
  'game.features': 'Spielfunktionen',
  'game.keyFeatures': 'Wichtigste Funktionen',
  'liveTable.title': 'Verfügbare Tische',
  'liveTable.totalResults': 'Gesamtergebnisse:',
  'liveTable.download': 'Tischdaten herunterladen',
  'liveTable.gameId': 'Spiel-ID',
  'liveTable.tableName': 'Tischname',
  'liveTable.minLimit': 'Min. Tischlimit',
  'liveTable.maxLimit': 'Max. Tischlimit',
  'liveTable.hours': 'Betriebszeiten UTC',
  'liveTable.language': 'Betriebssprache',
  'liveTable.releaseDate': 'Veröffentlichungsdatum',
  'liveTable.location': 'Standort',
  'game.betLevels': 'Einsatzstufen',
  'game.tableRules': 'Tischregeln',
  'game.mathConfig': 'Mathematische Konfiguration',
  'game.resources': 'Ressourcen',
  'game.relatedAssets': 'Zugehörige Assets',
  'game.releaseRoadmap': 'Release-Roadmap',
  'game.integrationGuidelines': 'Integrationsrichtlinien',
  'game.information': 'Spielinformationen',
  'game.availableOn': 'Available On',
  'game.operatingLanguage': 'Operating Language',
  'game.uiLanguages': 'UI Languages',
  'game.platformDesktop': 'Desktop',
  'game.platformTablet': 'Tablet',
  'game.platformMobile': 'Mobil',
  'game.downloads': 'Downloads',
  'game.mediaPack': 'Media Pack',
  'game.gameData': 'Game Data (PDF)',
  'game.download': 'Download',
  'game.gameDataSoon': 'Das Spieldatenblatt wird in Kürze hinzugefügt.',

  'spec.numericId': 'Numerische ID',
  'spec.minBetPerLine': 'Mindesteinsatz pro Linie',
  'spec.minTotalBet': 'Mindestgesamteinsatz',
  'spec.maxTotalBet': 'Maximaler Gesamteinsatz',
  'spec.maxTotalBetAnte': 'Max. Gesamteinsatz mit Ante',
  'spec.reels': 'Walzen',
  'spec.rows': 'Reihen',
  'spec.payType': 'Gewinnart',
  'spec.payLinesValue': '{count} Linien',
  'spec.symbolPays': 'Symbolgewinne',
  'spec.betMultiplier': 'Einsatzmultiplikator',
  'spec.maxMultiplierWin': 'Max. Multiplikatorgewinn',
  'spec.maxExposure': 'Maximales Risiko',
  'spec.bonusBuyX': 'Bonuskauf X',
  'spec.anteBetX': 'Ante-Einsatz X',
  'spec.rtps': 'RTP-Werte',
  'spec.hitFrequency': 'Trefferhäufigkeit',
  'spec.oneIn': '1 von {value}',
  'spec.hasReplay': 'Replay',
  'spec.hasBuySpins': 'Spins kaufen',
  'spec.hasInstantBonus': 'Sofortbonus',
  'spec.hasHyperplay': 'Hyperplay',
  'spec.hasAnteBet': 'Ante-Einsatz',
  'spec.releaseDate': 'Veröffentlichungsdatum',
  'spec.symbol': 'Spielsymbol',
  'spec.referenceId': 'Referenz-ID',
  'spec.provider': 'Anbieter',
  'spec.product': 'Produkt',
  'spec.gameType': 'Spieltyp',
  'spec.category': 'Kategorie',
  'spec.theme': 'Thema',
  'spec.technology': 'Technologie',
  'spec.rtp': 'RTP',
  'spec.volatility': 'Volatilität',
  'spec.maxWin': 'Maximalgewinn',
  'spec.paylines': 'Gewinnlinien',
  'spec.grid': 'Raster',
  'spec.bonusFrequency': 'Bonusfrequenz',
  'spec.bonusFrequencyValue': '1 von {value}',
  'spec.jackpot': 'Jackpot',
  'spec.betRange': 'Einsatzbereich',
  'spec.defaultBet': 'Standardeinsatz',
  'spec.currency': 'Währung',
  'spec.languages': 'Sprachen',
  'spec.demoAvailable': 'Demo verfügbar',
  'spec.tournaments': 'Turniere',
  'spec.highlighted': 'Hervorgehoben',
  'spec.status': 'Status',
  'spec.version': 'Version',
  'spec.lastUpdated': 'Zuletzt aktualisiert',

  'roadmap.eyebrow': 'Produkt-Roadmap',
  'roadmap.title': 'Was kommt',
  'roadmap.lead': 'Verfolgen Sie kommende Releases und veröffentlichte Titel nach Kategorie.',
  'roadmap.bannerAria': 'Kommende Releases',
  'roadmap.soonTitle': 'Demnächst',
  'roadmap.loading': 'Roadmap wird geladen…',
  'roadmap.error': 'Die Roadmap-Einträge konnten nicht geladen werden.',
  'roadmap.emptyTitle': 'Keine Roadmap-Einträge',
  'roadmap.emptyMessage': 'Für diese Kategorie gibt es noch keine veröffentlichten Einträge.',
  'roadmap.itemCount': '{count} Einträge',
  'roadmap.target': 'Ziel: {date}',
  'roadmap.viewInLibrary': 'In der Bibliothek ansehen',

  'upcoming.title': 'Bevorstehende Releases',
  'upcoming.playDemo': 'Demo spielen',
  'upcoming.prev': 'Vorherige Releases',
  'upcoming.next': 'Nächste Releases',

  'assets.eyebrow': 'Markenassets',
  'assets.title': 'Asset-Pakete',
  'assets.lead':
    'Laden Sie Logos, Key Art und Marketingmaterialien herunter. Nutzungsregeln finden Sie in {link}.',
  'assets.leadLink': 'den Asset-Richtlinien',
  'assets.loading': 'Assets werden geladen…',
  'assets.error': 'Die Asset-Pakete konnten nicht geladen werden.',
  'assets.downloadFailed': 'Download fehlgeschlagen.',
  'assets.emptyTitle': 'Noch keine Assets',
  'assets.emptyForGame': 'Diesem Spiel sind keine Asset-Pakete zugeordnet.',
  'assets.emptyGeneral': 'Asset-Pakete erscheinen hier, sobald sie veröffentlicht sind.',
  'assets.pack': 'Paket',
  'assets.updated': 'Aktualisiert am {date}',
  'assets.download': 'Herunterladen',
  'assets.search': 'Nach Spielname suchen…',
  'assets.searchEmpty': 'Kein Spiel passt zu diesem Namen.',

  'guidelines.eyebrow': 'Dokumentation',
  'guidelines.title': 'Richtlinien',
  'guidelines.lead': 'Integrationshinweise, Asset-Nutzung und Betreiberreferenzen.',
  'guidelines.all': 'Alle',
  'guidelines.integration': 'Integration',
  'guidelines.assets': 'Assets',
  'guidelines.loading': 'Richtlinien werden geladen…',
  'guidelines.error': 'Die Richtlinien konnten nicht geladen werden.',
  'guidelines.emptyTitle': 'Keine Richtlinien',
  'guidelines.emptyMessage': 'Veröffentlichte Richtlinien erscheinen hier.',
  'guidelines.index': 'Übersicht',
  'guidelines.navAria': 'Richtlinien-Navigation',
  'guidelines.articleLoading': 'Artikel wird geladen…',
  'guidelines.notFound': 'Richtlinie nicht gefunden.',
  'guidelines.notFoundShort': 'Nicht gefunden',
  'guidelines.updated': 'Aktualisiert am {date}',
  'guidelines.external': 'Der Inhalt wird extern gehostet.',
  'guidelines.openDocument': 'Dokument öffnen',
  'guidelines.typeGuide': 'Leitfaden',
  'guidelines.typeGuideline': 'Richtlinie',

  'account.eyebrow': 'Ihr Konto',
  'account.title': 'Profil',
  'account.email': 'E-Mail',
  'account.language': 'Oberflächensprache',
  'account.recentActivity': 'Letzte Aktivität',
  'account.loadingActivity': 'Aktivität wird geladen…',
  'account.activityUnavailable': 'Die letzte Aktivität ist derzeit nicht verfügbar.',
  'account.noActivity': 'Keine aktuelle Aktivität erfasst.',

  'event.login': 'Angemeldet',
  'event.logout': 'Abgemeldet',
  'event.libraryView': 'Bibliothek angesehen',
  'event.gameView': 'Spiel angesehen',
  'event.demoLaunch': 'Demo gestartet',
  'event.demoLaunchFailed': 'Demostart fehlgeschlagen',
  'event.assetDownload': 'Asset heruntergeladen',
  'event.guidelineView': 'Richtlinie angesehen',
  'event.roadmapView': 'Roadmap angesehen',

  'auth.title': 'Kundenportal',
  'auth.subtitle': 'Melden Sie sich mit Ihren Betreiber-Zugangsdaten an',
  'auth.email': 'E-Mail',
  'auth.password': 'Passwort',
  'auth.rememberMe': 'Angemeldet bleiben',
  'auth.signIn': 'Anmelden',
  'auth.signInFailed': 'Anmeldung fehlgeschlagen',
  'auth.signInError':
    'Anmeldung nicht möglich. Prüfen Sie Ihre Zugangsdaten und versuchen Sie es erneut.',
  'auth.forgotPassword': 'Passwort vergessen?',
  'auth.inviteOnly': 'Zugang nur auf Einladung. Wenden Sie sich an Ihren RichyPlay-Ansprechpartner.',
  'auth.visitSiteAria': 'Zu richyplay.live wechseln',

  'footer.navAria': 'Fußzeile',
  'footer.tagline': 'Betreiberportal für den Slot- und Live-Casino-Katalog von RichyPlay.',
  'footer.rights': 'Alle Rechte vorbehalten.',
  'footer.legal':
    'Zugang auf Einladung für lizenzierte Betreiber. Nur für geschäftliche Nutzung.',

  'forgot.eyebrow': 'Passwort zurücksetzen',
  'forgot.title': 'Passwort vergessen',
  'forgot.requestSubtitle':
    'Geben Sie Ihre E-Mail-Adresse ein. Wir senden einen Bestätigungscode, falls ein Konto existiert.',
  'forgot.sendCode': 'Code senden',
  'forgot.sendError': 'Der Bestätigungscode konnte nicht gesendet werden.',
  'forgot.confirmSubtitle':
    'Geben Sie den Code aus Ihrer E-Mail ein und wählen Sie ein neues Passwort.',
  'forgot.code': 'Bestätigungscode',
  'forgot.newPassword': 'Neues Passwort',
  'forgot.update': 'Passwort aktualisieren',
  'forgot.updateError': 'Das Passwort konnte nicht zurückgesetzt werden.',
  'forgot.doneSubtitle': 'Ihr Passwort wurde aktualisiert. Sie können sich jetzt anmelden.',
  'forgot.backToSignIn': 'Zurück zur Anmeldung',
};
